var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { withRouter } from "react-router";
import { MediaAPI, errorToString, } from "bpm-client-api";
import Hls from "hls.js";
import * as SocketIOClient from "socket.io-client";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import Input from "reactstrap/lib/Input";
import autoscroll from 'autoscroll-react';
import Picker from 'emoji-picker-react';
import * as toastr from 'toastr';
import { useHistory } from "react-router-dom";
import { shareLink } from "../manager";
import { EYE_SVG, SHARE_SVG, VERIFIED_BLUE_SVG, PROFILE_PICTURE_RED } from "../assets";
var LiveInner = /** @class */ (function (_super) {
    __extends(LiveInner, _super);
    function LiveInner(props) {
        var _this = _super.call(this, props) || this;
        _this.onViewerCountChange = function (viewerCount) {
            _this.setState({ viewCount: viewerCount });
        };
        _this.state = {
            loading: true,
            streaming: false,
            viewCount: 0,
        };
        _this.onResize = _this.onResize.bind(_this);
        _this.onVideoEnded = _this.onVideoEnded.bind(_this);
        return _this;
    }
    LiveInner.prototype.componentDidMount = function () {
        this.load();
        window.addEventListener('resize', this.onResize);
    };
    LiveInner.prototype.componentWillUnmount = function () {
        this.resetStyle();
        this.reloadTimer && clearTimeout(this.reloadTimer);
        window.removeEventListener('resize', this.onResize);
        this.resizeTimer && clearTimeout(this.resizeTimer);
    };
    LiveInner.prototype.setStyle = function (ref) {
        var videoElem = document.getElementById('bpmlive');
        var offset = ref.getBoundingClientRect();
        videoElem.style.position = 'absolute';
        videoElem.style.top = (offset.top + (window.pageYOffset || 0)) + 20 + "px";
        videoElem.style.left = offset.left - 5 + "px";
        videoElem.style.height = ref.clientHeight - 40 + "px";
        videoElem.style.width = ref.clientWidth - 40 + "px";
        videoElem.style.visibility = 'visible';
    };
    LiveInner.prototype.onVideoEnded = function () {
        this.load().removeEventListener('ended', this.onVideoEnded);
    };
    LiveInner.prototype.resetStyle = function () {
        var videoElem = document.getElementById('bpmlive');
        videoElem.style.top = '0px';
        videoElem.style.left = '0px';
        videoElem.style.height = '0px';
        videoElem.style.width = '0px';
        videoElem.style.visibility = 'hidden';
        videoElem.removeEventListener('ended', this.onVideoEnded);
    };
    LiveInner.prototype.initHLS = function (src, video, live) {
        this.lastSrc = src;
        if (video.canPlayType('application/vnd.apple.mpegurl') || !live) {
            video.src = src;
            video.play();
        }
        else if (Hls.isSupported()) {
            if (this.hls) {
                this.hls.destroy();
            }
            this.hls = new Hls();
            this.hls.loadSource(src);
            this.hls.attachMedia(video);
            this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
                video.play();
            });
        }
    };
    LiveInner.prototype.load = function (showLoading) {
        var _this = this;
        if (showLoading === void 0) { showLoading = true; }
        var videoElem = document.getElementById('bpmlive');
        if (videoElem.src && videoElem.playbackRate == 0) {
            this.setState({ loading: false });
            videoElem.play();
        }
        MediaAPI.getLiveStatus().then(function (status) {
            var streaming = status.status.create == 'Live';
            var streamUrl = streaming ? status.stream_url : status.placeholder_stream_url_mp4;
            if (streamUrl != _this.lastSrc) {
                _this.initHLS(streamUrl, videoElem, streaming);
            }
            _this.setState({ streaming: streaming, loading: false, liveTitle: status.stream.title });
            if (!streaming) {
                videoElem.loop = true;
                _this.reloadTimer = setTimeout(function () {
                    _this.load(false);
                }, 1000 * 60 * 30);
            }
            else {
                videoElem.loop = false;
                videoElem.muted = false;
                videoElem.addEventListener('ended', _this.onVideoEnded);
            }
        }).catch(function (err) {
            errorToString(err).forEach(function (error) {
                toastr.error(error);
            });
        });
        return videoElem;
    };
    LiveInner.prototype.onResize = function () {
        var _this = this;
        this.resizeTimer && clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(function () {
            if (_this.containerDiv) {
                _this.setStyle(_this.containerDiv);
            }
        }, 650);
    };
    LiveInner.prototype.getAvailHeight = function () {
        if (this.props.maxHeight) {
            return this.props.maxHeight;
        }
        return 650;
    };
    LiveInner.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: 'video-split-view' },
            React.createElement("div", { className: "vid-container" },
                React.createElement("div", { className: "video-title-container" },
                    React.createElement("div", { className: "video-title" }, this.state.liveTitle),
                    React.createElement("div", { className: "live-text" }, "LIVE")),
                React.createElement("div", { className: "video-container", style: { height: this.getAvailHeight() + "px" }, ref: function (ref) {
                        if (ref) {
                            _this.containerDiv = ref;
                            _this.setStyle(ref);
                        }
                    } }),
                React.createElement("div", { className: "under-vid-container" },
                    React.createElement("div", { className: "view-text-container" },
                        React.createElement("img", { src: EYE_SVG, alt: "eye", className: "eye-svg" }),
                        React.createElement("div", { className: "view-text" }, this.state.viewCount)),
                    React.createElement("div", { className: "share-container" },
                        React.createElement("img", { src: SHARE_SVG, alt: "share", className: "share-icon" }),
                        React.createElement("div", { className: "share-text", onClick: function () { return shareLink(window.location.href); } }, "Share the stream")))),
            React.createElement(Chat, { height: this.props.maxHeight && this.props.maxHeight + 60, onViewerCountChange: this.onViewerCountChange })));
    };
    return LiveInner;
}(React.Component));
var ChatList = autoscroll(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.render = function () {
        var _a = this.props, messages = _a.messages, props = __rest(_a, ["messages"]);
        return (React.createElement("div", __assign({ style: { overflow: 'scroll', maxHeight: 'calc(100% - 110px)', marginTop: 20 } }, props), messages.map(function (message) {
            return React.createElement("div", { className: 'chat-message', key: message.id, style: { color: 'pink !important' } },
                React.createElement("div", { className: "username" },
                    React.createElement("span", { style: { color: message.color, marginRight: 8 } }, message.from),
                    message.admin ?
                        React.createElement("img", { className: "admin-icon", src: VERIFIED_BLUE_SVG, alt: "admin icon" })
                        : null),
                React.createElement("span", { className: 'chat-message-text' }, message.message));
        })));
    };
    return class_1;
}(React.Component)), { isScrolledDownThreshold: 20 });
export var Live = withRouter(LiveInner);
function Chat(props) {
    var _a = React.useState(''), message = _a[0], setMessage = _a[1];
    var _b = React.useState([]), messages = _b[0], setMessages = _b[1];
    var _c = React.useState(0), viewerCount = _c[0], setViewerCount = _c[1];
    var _d = React.useState(false), showEmojiPopup = _d[0], setShowEmojiPopup = _d[1];
    var socket = React.useRef();
    var history = useHistory();
    React.useEffect(function () {
        props.onViewerCountChange &&
            props.onViewerCountChange(viewerCount);
    }, [viewerCount]);
    React.useEffect(function () {
        socket.current = SocketIOClient.connect('https://chat.bpmsupreme.com', { transports: ['websocket'], reconnectionAttempts: 3 });
        socket.current.on('message', function (args) {
            var messagesToAdd = args.message ? [args.message] : (args.messages ? args.messages : []);
            var viewerCount = args.viewerCount;
            setMessages(function (messages) {
                return messages.concat(messagesToAdd).unique('id');
            });
            setViewerCount(viewerCount);
        });
        return function () {
            socket.current && socket.current.disconnect();
        };
    }, []);
    return (React.createElement("div", { className: "chat-container", style: {
            height: (props.height || 650) + "px"
        } },
        React.createElement(Row, { style: {
                flex: 1,
                overflow: 'hidden'
            } },
            React.createElement(Col, { className: "list", style: {
                    overflow: 'hidden',
                    maxHeight: '100%'
                } },
                React.createElement(Row, { className: "top-text-container" },
                    React.createElement("div", { className: "above-title" }, "Join the Conversation"),
                    React.createElement("div", { className: "under-title" },
                        "Click\u00A0",
                        React.createElement("span", { className: "here-text", onClick: function () { return history.push('/account'); } }, "here"),
                        " to change your username")),
                React.createElement("div", { className: "divider" }),
                React.createElement(ChatList, { messages: messages, onScrolled: function () { } }))),
        React.createElement(Row, { className: "message-box" },
            React.createElement(Col, null,
                React.createElement("div", { className: "pick-emoji-window " + (showEmojiPopup ? '' : 'hide') },
                    React.createElement(Picker, { onEmojiClick: function (event, emojiObject) {
                            setMessage(function (message) { return message + emojiObject.emoji; });
                            var input = document.querySelector('.chat-message-input');
                            input.focus();
                            setShowEmojiPopup(false);
                        } })),
                React.createElement("div", { className: "click-emoji-icon", onClick: function () {
                        setShowEmojiPopup(!showEmojiPopup);
                    } }, "\uD83D\uDE42"),
                React.createElement(Input, { type: "text", className: 'chat-message-input', style: {
                        resize: 'none'
                    }, placeholder: 'Send a message', value: message || '', onKeyUp: function (e) {
                        if (e.key === "Enter") {
                            if (socket.current && message != '') {
                                socket.current.send({
                                    message: message,
                                    time: new Date()
                                });
                                setMessage('');
                            }
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }, onChange: function (val) {
                        setMessage(val.target.value);
                    } }),
                React.createElement("i", { className: "far fa-meh-blank" }))),
        React.createElement(Row, { style: {
                alignItems: 'center',
                marginTop: 20,
                display: 'none'
            } },
            React.createElement(Col, null,
                React.createElement("img", { src: PROFILE_PICTURE_RED, width: 24 }),
                React.createElement("span", { style: {
                        marginLeft: 8
                    }, className: 'chat-message-text' }, viewerCount || 0)))));
}
//# sourceMappingURL=Live.js.map